import { render, staticRenderFns } from "./JVxeNormalCell.vue?vue&type=template&id=f2c270c4&scoped=true"
import script from "./JVxeNormalCell.vue?vue&type=script&lang=js"
export * from "./JVxeNormalCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c270c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c270c4')) {
      api.createRecord('f2c270c4', component.options)
    } else {
      api.reload('f2c270c4', component.options)
    }
    module.hot.accept("./JVxeNormalCell.vue?vue&type=template&id=f2c270c4&scoped=true", function () {
      api.rerender('f2c270c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/cells/JVxeNormalCell.vue"
export default component.exports